import { useCallback, useState } from 'react';
import NoticeList from 'components/board/noticeList';
import {goToLocation} from 'assets/js/commonUtil';
import 'assets/css/main.scss';
import Popup from 'components/main/popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesDown } from '@fortawesome/free-solid-svg-icons';
import PartnersComponent from "components/disribution/partners";

const Main = () => {

  const partnerRendering = () => {
    const result = [];

    for (let i = 1; i <= 10; i++) {
      const urlIndex = i < 10 ? '0' + i : i;
      result.push(
        <div className="img-style" key={i}>
          <img src={`https://img.chunhomall.com/images/brand_site/main-section-partner_${urlIndex}_300x150.jpg.jpg`} alt="Partner Image" />
        </div>
      );
    }

    return result;
  }

  const ItemHandler = (e: React.MouseEvent<HTMLElement>) => {
    
  }
  
  return (
    <>
      <div className="main-img-wrapper main-wrapper">
        <div className="main-img-text">
          <div className='top'>
            NATURE NUTRITION NEXT
          </div>
          <div className='middle'>
            42년 오직 한 길만,<br/>
            ‘하늘(天) 아래 좋은(好) 것만’ 담아
          </div>
          <div className='bottom'>
            삶을 건강하게 케어합니다.
          </div>
          <div className='btn-wrapper'>
            <div className='btn-more' onClick={() => goToLocation('/introduction')}>VIEW MORE</div>
          </div>
          
        </div>
        <div className='btn-down'><FontAwesomeIcon icon={faAnglesDown} /></div>
        <img src='https://img.chunhomall.com/images/brand_site/main-hero_1920x1080.jpg.jpg' alt="Main Image" className="responsive-image" />
        
      </div>
      <div className="main-process-img-wrapper main-wrapper">
        
        <div className='main-process'>
          <div className='title'>
            <div className='title-text'>
              OEM.ODM 진행절차<div className='sub-title'>맞춤 생산 서비스 제공</div>
            </div>
            <div className='title-btn'>
              <span className="btn-step1">기업 포트폴리오</span>
              <span className="btn-step2" onClick={() => goToLocation('/partners')}>VIEW MORE</span>
            </div>
          </div>
        </div>
        <img className="main-process-img pc" src='https://img.chunhomall.com/images/brand_site/main-section-oem_1920x1080.jpg.jpg' alt="Main Image" />
        <img className="main-process-img mo" src='https://img.chunhomall.com/images/brand_site/m-main-section-oem_400x1080.jpg.jpg' alt="Main Image" />
        
        <div className='main-process-mo top'>
          <div className='title'>
            <div className='title-text'>
              OEM.ODM 진행절차<div className='sub-title'>맞춤 생산 서비스 제공</div>
            </div>
          </div>
        </div>

        <div className='main-process-mo bottom'>
          <div className='title'>
            <div className='title-btn'>
              <span className="btn-step1">기업 포트폴리오</span>
              <span className="btn-step2" onClick={() => goToLocation('/partners')}>VIEW MORE</span>
            </div>
          </div>
        </div>
        
      </div>
      <div className='main-research-wrapper main-wrapper'>
        <div className='main-research'>
          <div className='title'>
            <div className='title-text'>
              천호엔케어R&D센터
            </div>
            <div className='sub-title'>
              ‘연구개발에 대한 아낌 없는 투자로 업계를 선도한다’는 원칙 아래 자체 연구소를 보유하고 있습니다.
            </div>
            <div className='title-btn'>
              <span className="btn-more" onClick={() => goToLocation('/research')}>VIEW MORE</span>
            </div>
          </div>
          <div className='img-research'>
            <img src="https://img.chunhomall.com/images/brand_site/main-section-rnd_600x400.jpg.jpg" alt='R&D'></img>    
          </div>
        </div>
      </div>

      <div className='main-partner-wrapper main-wrapper'>
        <div className='main-partner'>
          <div className='title'>
            <div className='title-text'>
              Trust Section<div className='sub-title'>다양한 기업이 선택한 건강기능식품 브랜드</div>
            </div>
            <div className='title-btn'>
              <span className="btn-step2" onClick={() => goToLocation('/partners')}>VIEW MORE</span>
            </div>
          </div>
          <div className='img-section'>
            <PartnersComponent strType="C"></PartnersComponent>
          </div>
        </div>
      </div>

      <div className='main-news-wrapper main-wrapper'>
        <div className='main-news'>
          <div className='title'>
            <div className='title-text'>
              NEWS<div className='sub-title'>다양한 소식을 전해드립니다.</div>
            </div>
            <div className='title-btn'>
              <span className="btn-step2" onClick={() => goToLocation('/board/noticenews')}>VIEW MORE</span>
            </div>
          </div>
          
          <NoticeList intType={11} />
          
        </div>
      </div>
      <div className='main-qa-wrapper main-wrapper'>
        <div className='main-qa'>
          <div className='title'>
            <div className='title-text'>
              문의하기
            </div>
            <div className='sub-title'>최고의 품질로 최상의 서비스를 제공합니다.</div>
            <div className='sub-title'>OEM/ODM 생상 상담이 필요하신가요?</div>

            <div className='title-btn'>
              <div className="btn-step1">고객센터</div>
              <div className="btn-step2" onClick={() => goToLocation('/proposal')}>문의하기</div>
            </div>
          </div>
        </div>
      </div>
      {/* <Popup/> */}
      
    </>
  );
}
  
  
export default Main;